// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faculty-profiles-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
}
.faculty-profiles-list .left-side {
  width: 100%;
}
.faculty-profiles-list .left-side .search {
  margin-bottom: 10px;
  width: 100%;
}
.faculty-profiles-list .left-side .faculty-info-button {
  margin-right: 5px;
}
.faculty-profiles-list .left-side .faculty-info-button .faculty-info-path {
  stroke: #28303f;
}
.faculty-profiles-list .left-side .faculty-info-button:hover {
  cursor: pointer;
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.faculty-profiles-list .left-side .faculty-info-button:hover .faculty-info-path {
  strokewidth: 1.5;
  stroke: white;
}
.faculty-profiles-list .left-side .no-add {
  border: 1px solid var(--light-grey);
  border-radius: 50%;
  fill: var(--light-grey);
}
.faculty-profiles-list .left-side .no-add .add-compare-path {
  stroke: white;
  fill: var(--light-grey);
}
.faculty-profiles-list .left-side .add-compare-button .add-compare-path {
  stroke: #28303f;
}
.faculty-profiles-list .left-side .add-compare-button:hover {
  cursor: pointer;
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.faculty-profiles-list .left-side .add-compare-button:hover .add-compare-path {
  strokewidth: 1.5;
  stroke: white;
}
.faculty-profiles-list .right-side {
  width: 20%;
  position: fixed;
  right: 5vw;
  z-index: 200;
}
.faculty-profiles-list .right-side .compare-block {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  padding: 20px 10px;
}
.faculty-profiles-list .right-side .compare-block p {
  font-size: 14px;
  margin: 10px 0 0 3px !important;
}
.faculty-profiles-list .right-side .compare-block .compare-list {
  display: flex;
  flex-wrap: wrap;
  color: rgba(0, 0, 0, 0.407);
}
.faculty-profiles-list .right-side .compare-block .compare-list .compare-item {
  border: 2px solid white;
  border-radius: 50%;
  padding: 2px;
}
.faculty-profiles-list .right-side .compare-block .compare-list .compare-item:hover {
  border: 2px solid var(--benchmarking-color);
}
.faculty-profiles-list .right-side .compare-block .keyword-add {
  margin-top: 10px;
}
.faculty-profiles-list .right-side .compare-block .button-compare {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.faculty-profiles-list .right-side .compare-block .button-compare button {
  border: none;
  color: white;
  background: var(--benchmarking-color);
  padding: 10px 15px;
  border-radius: 10px;
  cursor: pointer;
}
.faculty-profiles-list .right-side .rank-block {
  margin-top: 50px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  padding: 20px 10px;
}
.faculty-profiles-list .right-side .rank-block .search {
  display: flex;
}
.faculty-profiles-list .right-side .rank-block button {
  margin-left: 5px;
  border: none;
  color: white;
  background: var(--benchmarking-color);
  height: 30px;
  width: 60px;
  border-radius: 5px;
  cursor: pointer;
}
.faculty-profiles-list .right-side .rank-block .example {
  display: flex;
  font-size: 12px;
  margin-top: 10px;
}
.faculty-profiles-list .right-side .rank-block .example p {
  font-weight: bold;
  margin-right: 10px !important;
}
.faculty-profiles-list .right-side .rank-block .example u {
  color: blue;
  cursor: pointer;
  margin-right: 5px;
}

.ant-drawer-content-wrapper .open-info p {
  font-size: 18px;
  margin-right: 10px !important;
}
.ant-drawer-content-wrapper .open-info:hover {
  cursor: pointer;
}
.ant-drawer-content-wrapper .open-info:hover p {
  color: var(--benchmarking-color);
}

.ant-tag {
  margin: 3px !important;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/FacultyProfiles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AADI;EACE,mBAAA;EACA,WAAA;AAGN;AADI;EACE,iBAAA;AAGN;AAFM;EACE,eAAA;AAIR;AADI;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,+BAAA;AAGN;AADM;EACE,gBAAA;EACA,aAAA;AAGR;AAAI;EACE,mCAAA;EACA,kBAAA;EACA,uBAAA;AAEN;AADM;EACE,aAAA;EACA,uBAAA;AAGR;AAEM;EACE,eAAA;AAAR;AAGI;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,+BAAA;AADN;AAEM;EACE,gBAAA;EACA,aAAA;AAAR;AAIE;EACE,UAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;AAFJ;AAGI;EACE,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AADN;AAEM;EACE,eAAA;EACA,+BAAA;AAAR;AAEM;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AAAR;AACQ;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;AACV;AACQ;EACE,2CAAA;AACV;AAEM;EACE,gBAAA;AAAR;AAEM;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AAAR;AACQ;EACE,YAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AACV;AAGI;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AADN;AAEM;EACE,aAAA;AAAR;AAEM;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAEM;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAAR;AACQ;EACE,iBAAA;EACA,6BAAA;AACV;AACQ;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AACV;;AAQI;EACE,eAAA;EACA,6BAAA;AALN;AAQE;EACE,eAAA;AANJ;AAOI;EACE,gCAAA;AALN;;AASA;EACE,sBAAA;AANF","sourcesContent":[".faculty-profiles-list {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n  .left-side {\n    width: 100%;\n    .search {\n      margin-bottom: 10px;\n      width: 100%;\n    }\n    .faculty-info-button {\n      margin-right: 5px;\n      .faculty-info-path {\n        stroke: #28303f;\n      }\n    }\n    .faculty-info-button:hover {\n      cursor: pointer;\n      border: 1px solid var(--benchmarking-color);\n      border-radius: 50%;\n      fill: var(--benchmarking-color);\n\n      .faculty-info-path {\n        strokewidth: 1.5;\n        stroke: white;\n      }\n    }\n    .no-add {\n      border: 1px solid var(--light-grey);\n      border-radius: 50%;\n      fill: var(--light-grey);\n      .add-compare-path {\n        stroke: white;\n        fill: var(--light-grey);\n      }\n    }\n\n    .add-compare-button {\n      .add-compare-path {\n        stroke: #28303f;\n      }\n    }\n    .add-compare-button:hover {\n      cursor: pointer;\n      border: 1px solid var(--benchmarking-color);\n      border-radius: 50%;\n      fill: var(--benchmarking-color);\n      .add-compare-path {\n        strokewidth: 1.5;\n        stroke: white;\n      }\n    }\n  }\n  .right-side {\n    width: 20%;\n    position: fixed;\n    right: 5vw;\n    z-index: 200;\n    .compare-block {\n      width: 100%;\n      border-radius: 10px;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n      padding: 20px 10px;\n      p {\n        font-size: 14px;\n        margin: 10px 0 0 3px !important;\n      }\n      .compare-list {\n        display: flex;\n        flex-wrap: wrap;\n        color: rgba(0, 0, 0, 0.407);\n        .compare-item {\n          border: 2px solid white;\n          border-radius: 50%;\n          padding: 2px;\n        }\n        .compare-item:hover {\n          border: 2px solid var(--benchmarking-color);\n        }\n      }\n      .keyword-add {\n        margin-top: 10px;\n      }\n      .button-compare {\n        margin-top: 10px;\n        display: flex;\n        justify-content: flex-end;\n        button {\n          border: none;\n          color: white;\n          background: var(--benchmarking-color);\n          padding: 10px 15px;\n          border-radius: 10px;\n          cursor: pointer;\n        }\n      }\n    }\n    .rank-block {\n      margin-top: 50px;\n      width: 100%;\n      border-radius: 10px;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n      padding: 20px 10px;\n      .search {\n        display: flex;\n      }\n      button {\n        margin-left: 5px;\n        border: none;\n        color: white;\n        background: var(--benchmarking-color);\n        height: 30px;\n        width: 60px;\n        border-radius: 5px;\n        cursor: pointer;\n      }\n      .example {\n        display: flex;\n        font-size: 12px;\n        margin-top: 10px;\n        p {\n          font-weight: bold;\n          margin-right: 10px !important;\n        }\n        u {\n          color: blue;\n          cursor: pointer;\n          margin-right: 5px;\n        }\n      }\n    }\n  }\n}\n\n.ant-drawer-content-wrapper {\n  .open-info {\n    p {\n      font-size: 18px;\n      margin-right: 10px !important;\n    }\n  }\n  .open-info:hover {\n    cursor: pointer;\n    p {\n      color: var(--benchmarking-color);\n    }\n  }\n}\n.ant-tag {\n  margin: 3px !important;\n}\n// .ant-tag .ant-tag-close-icon {\n//   color: white;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
